<form class="search-form">
  <div class="input-wrapper">
    <input
      id="search-layer-input-field"
      class="search-input"
      type="text"
      matInput
      [formControl]="searchFormControl"
      [title]="currentTitle"
      placeholder="Søk kartlag"
      [matAutocomplete]="auto"
      (keydown)="customStopPropagation($event)" />
    @if (searchFormControl.value) {
      <button
        type="button"
        class="cancel-btn"
        disableRipple
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="clearSearch()"
        (keydown.enter)="clearSearch()">
        <mat-icon class="cancel-icon">close</mat-icon>
      </button>
    }
  </div>
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onChange($event.option.value)">
    @for (layer of stateGroupOptions; track layer) {
      <mat-option [value]="layer" class="compact-option">
        <span class="search-result-text"> {{ layer.label }} — {{ layer.parentLabel }} </span>
      </mat-option>
    }
  </mat-autocomplete>
</form>
